function updateBreadcrumbOffset() {
  const header = document.querySelector('.theme__header');
  const breadcrumbs = document.querySelector('.new-breadcrumbs');

  if (!header || !breadcrumbs) return;

  const headerHeight = header.offsetHeight;
  // breadcrumbs.style.transform = `translateY(${headerHeight}px)`;
}

// 初期実行
document.addEventListener('DOMContentLoaded', updateBreadcrumbOffset);
window.addEventListener('load', updateBreadcrumbOffset);
window.addEventListener('resize', updateBreadcrumbOffset); // 画面サイズ変更に対応

/* assets/breadcrumb-meganav-sync.js など */
document.addEventListener('DOMContentLoaded', () => {
  const bc = document.querySelector('.new-breadcrumbs__holder');
  if (!bc) return;

  /* パンくずホルダーの高さを取得してグローバル変数に格納  */
  const h = bc.offsetHeight; // 例: 40
  document.documentElement.style.setProperty('--BC-HEIGHT', h + 'px');
});
